/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();
      this.setAnimations();
      this.setHotspotTouch();

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', (event) => {
          this.setAnimations();
          if (typeof ScrollTrigger !== 'undefined') {
            setTimeout(() => { ScrollTrigger.refresh(); }, 100);
          }
        });
      }
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }

    setAnimations() {
      if (typeof ScrollTrigger === 'undefined' || typeof gsap === 'undefined') return;
      ScrollTrigger.batch(this.querySelectorAll('figure'), {
        start: "top 90%",
        onEnter: (elements) => {
          gsap.to(elements, { opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        },
      });
    }

    setHotspotTouch() {
  const hotspots = this.querySelectorAll('.gallery-hotspot');
  hotspots.forEach((hotspot) => {
    hotspot.addEventListener('touchstart', (e) => {
      // CTA linkine dokunuluyorsa preventDefault çalıştırma — link navigate etsin
      if (e.target.closest('.gallery-hotspot__cta')) return;

      const isOpen = hotspot.classList.contains('is-open');
      hotspots.forEach(h => h.classList.remove('is-open'));
      if (!isOpen) {
        e.preventDefault();
        hotspot.classList.add('is-open');
      }
    }, { passive: false });
  });

  document.addEventListener('touchstart', (e) => {
    if (!e.target.closest('.gallery-hotspot')) {
      hotspots.forEach(h => h.classList.remove('is-open'));
    }
  });
}

  }
  customElements.define('theme-gallery', ThemeGallery);
}
